export default __webpack_public_path__ + "static/media/list.6d68a14b.svg";